import {AutoLinkPlugin as LexicalAutoLinkPlugin} from '@lexical/react/LexicalAutoLinkPlugin';

export const URL_MATCHER =
  /((https?:\/\/(www\.)?)|(www\.))[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;

const EMAIL_MATCHER =
  /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;

// Do not treat model/version strings such as "GPT-5.6" as Jira issue keys.
// Lexical's auto-link transform otherwise links "GPT-5", notices that the
// adjacent ".6" makes the link invalid, unwraps it, and repeats indefinitely.
const JIRA_KEY_MATCHER = /\b[A-Z]+-\d+\b(?!\.\d)/;

export const jiraLinkMatcher = (text: string) => {
  const match = JIRA_KEY_MATCHER.exec(text);
  return (
    match && {
      index: match.index,
      length: match[0].length,
      text: match[0],
      url: `https://jira.dropboxer.net/browse/${match[0]}`,
    }
  );
};

// Internal URL matcher for URLs like http://drl/*
export const INTERNAL_URL_MATCHER = /https?:\/\/[a-zA-Z0-9-]+\/[^\s]*/;

const MATCHERS = [
  // Internal URLs first (more specific)
  (text: string) => {
    const match = INTERNAL_URL_MATCHER.exec(text);
    return (
      match && {
        index: match.index,
        length: match[0].length,
        text: match[0],
        url: match[0],
      }
    );
  },
  (text: string) => {
    const match = URL_MATCHER.exec(text);
    return (
      match && {
        index: match.index,
        length: match[0].length,
        text: match[0],
        url: match[0],
      }
    );
  },
  (text: string) => {
    const match = EMAIL_MATCHER.exec(text);
    return (
      match && {
        index: match.index,
        length: match[0].length,
        text: match[0],
        url: `mailto:${match[0]}`,
      }
    );
  },
  jiraLinkMatcher,
  // // ldap links to profile
  // (text: string) => {
  //   const match = /@([a-zA-Z0-9-]+)/.exec(text);
  //   return (
  //     match && {
  //       index: match.index,
  //       length: match[0].length,
  //       text: match[0],
  //       url: `${getFrontendUrl()}people/${match[1]}`,
  //     }
  //   );
  // },
  // // Slack #channels
  // (text: string) => {
  //   const match = /#([a-zA-Z0-9-]+)/.exec(text);
  //   return (
  //     match && {
  //       index: match.index,
  //       length: match[0].length,
  //       text: match[0],
  //       url: `https://dropbox.slack.com/archives/${match[1]}`,
  //     }
  //   );
  // },
];

export const AutoLinkPlugin = () => {
  return <LexicalAutoLinkPlugin matchers={MATCHERS} />;
};
